export default class BeEndpoints {
  //general
  static BASE_BE_URL = process.env.PREACT_APP_DJ_BASE_PATH;

  //accounts
  static LOGIN = "/account/host/login";
  static LOGOUT = "/account/host/logout";
  static PROFILE = "/account/host/profile";
  static VENUE = "account/host/active/venue";

  static CHANGE_PASSWORD = "/account/host/change-password";

  //tracks
  static TRACK_DETAILS = "/tracks/track";
  static GET_TRACKS = "/tracks/track/all";
  static SEARCH_TRACKS = "/tracks/track/search";
  static SONG_REQUESTS = "/tracks/request/all";
  static UPDATE_SONG_STATUS = "/tracks/track/host/status";
  static TOP_SONGS = "/tracks/top";
  static TRACK_ACTION = "/tracks/host/request";
  static SPOTIFY_SEARCH = "/tracks/track/spotify/search";
  static REQUESTED_GUEST_SONG = "/tracks/request/user/details";

  //Playlists
  static CREATE_PLAYLIST = "/playlists/playlist";
  static ADD_PLAYLIST_TAG = "/playlists/playlist/slotmap";
  static FETCH_ALL_PLAYLISTS = "/playlists/playlist/options";
  static FETCH_ALL_PLAYLISTS_DASHBOARD = "/playlists/playlist/all";
  static PLAYLIST_DETAILS = "/playlists/playlist/details";
  static ADD_PLAYLIST_SONG = "/playlists/playlist/track/add";
  static ALL_MASTER_PLAYLIST = "/playlists/playlist/master";

  //slots
  static GET_ALL_SLOTS = "/slots/slot/all";
  static SLOT_UPDATE = "/slots/slot";
  static SLOT_AUTO_ACCEPT = "/slots/slot/accept";

  //ratings
  static HOST_UPDATE = "/account/host/rating/all";
}
